<template>
  <div
    :class="[
      { 'is-checked': checked },
      { 'is-modified': modified },
      { 'is-readonly': readonly },
      size
    ]"
    :aria-checked="checked"
    class="checkbox"
    role="checkbox"
    tabindex="0"
    @keypress.enter.space.prevent="toggle"
    @click="toggle()"
  >
    <font-awesome-icon v-if="checked" icon="check" size="lg" />
    <!--Needed to prevent checkbox with 'tiny' style being displaced when unchecked -->
    <span v-else>&nbsp;</span>
  </div>
</template>
<script>
export default {
  name: 'Checkbox',
  model: {
    prop: 'checked',
    event: 'change'
  },
  props: {
    checked: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: 'regular'
    },
    modified: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    toggle() {
      if (!this.readonly) {
        this.$emit('change', { checked: !this.checked });
      }
    }
  }
};
</script>
<style lang="scss" scoped>
@import '../styles/colors.scss';
.checkbox {
  background-color: $background-light;
  text-align: center;
  color: white;
  &:hover {
    cursor: pointer;
  }

  &.is-checked {
    background-color: $text-color-dark-3;
  }

  &.is-readonly,
  &[readonly] {
    background-color: transparent;
    color: $text-color-dark-3;
  }

  &.address-readonly {
    background-color: $light-grey-1;
    color: $text-color-dark-3;
    pointer-events: none;
  }

  &.is-modified {
    border: 2px solid $orange;
  }
  &:focus {
    outline: none;
  }
  &.regular {
    height: 37px;
    width: 37px;
    padding-top: 8px;
  }
  &.small {
    width: 27px;
    height: 27px;
    padding-top: 4px;
  }
  &.tiny {
    width: 20px;
    height: 20px;
    font-size: 0.5em;
    display: inline-block;
    margin: 0 5px;
    line-height: 20px;
  }
}

@media print {
  .checkbox,
  .checkbox.is-checked,
  .checkbox.is-modified {
    background-color: $white;
    color: $black;
  }
}
</style>
